import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'
import { ElementRef, Pipe, PipeTransform } from '@angular/core';
import { HttpParams } from '@angular/common/http'
import stripJsonComments from 'strip-json-comments';

import { elementAt, map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

// import { PedidoCabecera } from '../models/pedidocabecera';

export function CuitValidator(control: AbstractControl): { [key: string]: boolean } | null { // 11 numeros, sin espacios ni caracteres especiales

  let cuit: string = control.value

  let num: boolean = false;
  num = !isNaN(Number(cuit.toString()));

  if (!num || cuit.length != 11)
    return { 'cuitPattern': true };

  return null;
}

export function defaultValueOrRangeValidator(
  defaultValue: number,
  ...rangeValidators: ValidatorFn[]
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == defaultValue) return null;

    for (let validator of rangeValidators) {
      if (validator(control)) return validator(control);
    }
  };
}


export function passwordValidator(control: FormControl) {
  const password: string = control.value

  const LOWERCASE_REGEX = /[a-z]/
  const UPPERCASE_REGEX = /[A-Z]/
  const DIGIT_REGEX = /(\d)/
  const SPECIAL_REGEX = /[\!\#\$(\)\*\+\-\=\<\>\?_\{\}\~]/

  const validations: Array<boolean> = [];

  validations.push(LOWERCASE_REGEX.test(password))
  validations.push(UPPERCASE_REGEX.test(password))
  validations.push(DIGIT_REGEX.test(password))
  validations.push(SPECIAL_REGEX.test(password))

  const passedValidations = validations.filter(passed => passed).length

  return passedValidations < 3 ? { passwordPattern: true } : null
}

export function passwordValidatorOld(control: FormControl) {
  const password: string = control.value

  const LOWERCASE_REGEX = /[a-z]/
  const UPPERCASE_REGEX = /[A-Z]/
  const DIGIT_REGEX = /(\d)/
  const SPECIAL_REGEX = /[\!\#\$(\)\*\+\-\=\<\>\?_\{\}\~]/

  const validations: boolean[] = []

  validations[0] = LOWERCASE_REGEX.test(password)
  validations[1] = UPPERCASE_REGEX.test(password)
  validations[0] = DIGIT_REGEX.test(password)
  validations[1] = SPECIAL_REGEX.test(password)

  const passedValidations = validations.filter(passed => passed).length


  return passedValidations < 1 ? { passwordPattern: true } : null
}

export function compareValidator(_value1: string, _value2: string) {
  return (group: FormGroup) => {
    const value1Control = group.get(_value1)
    const value1: string = value1Control.value

    const value2Control = group.get(_value2)
    const value2: string = value2Control.value

    if (value1 !== value2) {
      value2Control.setErrors({ compare: true })
    } else {
      value2Control.setErrors(null)
    }
  }
}

export function loadData(group: FormGroup, object: any) {
  for (const propName in object) {

    if (object[propName] != null) {
      const control = group.get(propName)

      if (control != null) {
        control.setValue(object[propName])
      }
    }
  }
  group.markAsUntouched();
  group.markAsPristine();
}

export function scrollToInvalidFromControls(element: ElementRef, formgroup: FormGroup) {
  formgroup.markAllAsTouched();
  if (formgroup.invalid) {
    // Got focus to the error field
    let invalidFields = [].slice.call(element.nativeElement.getElementsByClassName('ng-invalid'));
    if (invalidFields.length) {
      invalidFields = invalidFields.filter(c => c.id != "");
      if (invalidFields.length) {
        invalidFields[0].scrollIntoView(({ behavior: "smooth", block: "start", inline: "nearest" }));

      }
    }
  }
}


export function LoadOrder(group: FormGroup, object: any) {
  for (const propName in object) {
    if (group.get(propName) != null) {

      let control = group.get(propName);

      if (typeof control.value === 'string' || typeof control.value === 'number'
        || typeof control.value === 'boolean') {
        object[propName] = control.value;
      }
      else if (control.value != null) {
        object[propName] = control.value.id
      }
      // control.setValue(object[propName])
    }
  }
}

export function LoadOrderWithDisables(group: any, object: any) {
  for (const propName in object) {
    if (group[propName] != null) {

      let control = group[propName];

      if (typeof control === 'string' || typeof control === 'number'
        || typeof control === 'boolean') {
        object[propName] = control;
      }
      else if (control != null) {
        object[propName] = control.id
      }
    }
  }
}

export function isMobile() {
  return window.screen.width <= 834;
}

export function isMobileXL() {
  return window.screen.width <= 1024;
}

export function isNotebook() {
  return window.screen.width <= 1368;
}

export function isDate(value: any) {
  return value instanceof Date;
}



export function toQueryString(obj): string {
  const parts = []

  for (const property in obj) {
    if (property != null) {
      let value = obj[property]

      if (value != null && value !== undefined) {
        if (isDate(value)) {
          value = value.toISOString()
        }

        parts.push(encodeURIComponent(property) + '=' + encodeURIComponent(value))
      }
    }
  }

  return parts.join('&')
}

export function toFormData(obj): FormData {
  const formData = new FormData()

  for (const property in obj) {
    if (property != null) {
      let value = obj[property]

      if (value != null && value !== undefined) {
        if (isDate(value)) {
          value = value.toISOString()
        }

        formData.append(property, value)
      }
    }
  }

  return formData
}

export function parseJson(jsonText: string): any {
  const stripedJson = stripJsonComments(jsonText)
  const json = JSON.parse(stripedJson)

  return json
}

export function parseDate(fecha: any) {

  let formateo = fecha.split(/\D+/);

  return new Date(formateo[2], -formateo[1], formateo[0], formateo[3], formateo[4], formateo[5]);
}

export function parseDatetoShort(str) {

  let date = new Date(str),

    mnth = ('0' + (date.getMonth() + 1)).slice(-2),

    day = ('0' + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join('-');
}

export function parseLocalShortDate(str) {

  let parts2a = str.split('/')

  // tslint:disable-next-line:radix
  const date2 = new Date(parseInt(parts2a[2]), parseInt(parts2a[1]) - 1, parseInt(parts2a[0]))


  let parseLocal2 = parseDatetoShort(new Date(date2))
  return parseLocal2
}


export class UtilsService {
  static buildQueryParams(source: Object): HttpParams {
    let target: HttpParams = new HttpParams()
    Object.keys(source).forEach((key: string) => {
      const value: string | number | boolean | Date = source[key]
      if (typeof value !== 'undefined' && value !== null) {
        target = target.append(key, value.toString())
      }
    })
    return target
  }
}

export function ClasePorEstado(idTipoOrden: string, id: string) {

  let clase: Array<string> = ['estado'];
  if (id !== '' && id !== null) {
    switch (idTipoOrden) {
      case "1":
        clase.push('estadoPV_' + id)
        break;
      case "5":
        clase.push('estadoPEP_' + id)
        break;
      case "3":
        clase.push('estadoNC_' + id)
        break;
      case "7":
        clase.push('estadoPA_' + id)
        break;
        case "8":
        clase.push('estadoTP_' + id)
        break;
        case "9":
          clase.push('estadoTD_' + id)
          break;
      case "12":
        clase.push('estadoCotizacion_' + id)
        break;
      case "10":
        clase.push('estadoPEPA_' + id)
        break;
      case "11":
        clase.push('estadoPVA_' + id)
        break;
      default:
        clase.push('estadoPV_' + id)
        break;
    }
  }
  return clase;
}

export function ClassByLegacy(id: string) {

  let clase: Array<string> = ['estadoLegacy'];
  if (id !== '' && id !== null) {
    clase.push('statusc_legacy' + id)
  }
  return clase;
}

export function CardClassByStatus(id: string) {

  let clase: Array<string> = [];
  if (id !== '' && id !== null) {
    clase.push('cardstatusc' + id)
  }
  return clase;
}

export function ClassByWorkFlowGlobal(id: string, pedidobriefcase: boolean) {

  let clase: Array<string> = ['rectborder'];
  if (!pedidobriefcase) {
    clase.push('status_wf' + id)
  }
  return clase;
}

export function ClassByWorkFlow(id: string) {

  let clase: Array<string> = ['circle_proceso1'];

  clase.push('status_wf' + id)

  return clase;
}

export function ClassByGlobo(id: string) {

  let clase: Array<string> = ['circle_proceso1'];
  return clase;
}


